<h1>{{ 'editCatalog.knowledge' | translate }}</h1>
<div class="edit-catalogue__edit-button-div">
  <button mat-raised-button [routerLink]="['/katalog']" class="save-btn">{{ 'general.cancel' | translate }}</button>
  <button mat-flat-button class="save-btn" [disabled]="!formChanged" (click)="saveKatalogItem()">{{ 'general.save' | translate }}</button>
</div>
<app-multiline-text-entry
  (changeEntrypoints)="addKenntnisse($event)"
  [entrypoints]="kentnisse"
  class="multi-entry"
></app-multiline-text-entry>


